<template>
  <el-select
    v-bind="$attrs"
    :value="unique"
    :filterable="filterable||allowCreate"
    :allow-create="allowCreate"
    v-on="new$listeners"
  >
    <el-option v-if="!!selectedOption" :key="-1" :label="selectedOption[labelField]||' '" :value="selectedOption[uniqueField]" />
    <el-option v-for="(item,index) in otherOptions" :key="index" :label="item[labelField]||' '" :value="item[uniqueField]" />
  </el-select>
</template>

<script>
export default {
  name: 'CargoRepeatValueSelect',
  props: {
    value: { type: [String, Number, Boolean], required: true },
    filterable: { type: Boolean, default: false },
    allowCreate: { type: Boolean, default: false },
    options: { type: Array, required: true },
    labelField: { type: String, required: true },
    valueField: { type: String, required: true },
    uniqueField: { type: String, required: true }, // 值唯一的字段名
    matchOfRepeatValue: { type: Function, required: true } // 重复值的匹配方法
  },
  data() {
    return {
      unique: '',
      selectedOption: null
    }
  },
  computed: {
    new$listeners() {
      return Object.assign(this.$listeners, { input: this.onInput, change: this.onChange })
    },
    otherOptions() {
      if (this.selectedOption) {
        return this.options.filter(p => p[this.uniqueField] !== this.selectedOption[this.uniqueField])
      } else {
        return [...this.options]
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.valueToUnique()
      }
    },
    allowCreate() {
      this.valueToUnique()
    },
    options() {
      this.valueToUnique()
    },
    valueField() {
      this.valueToUnique()
    },
    uniqueField() {
      this.valueToUnique()
    }
  },
  methods: {
    valueToUnique() {
      this.selectedOption = null
      const options = this.options.filter(p => p[this.valueField] === this.value)
      if (options.length > 0) {
        if (options.length === 1) {
          this.selectedOption = options[0]
          this.unique = this.selectedOption[this.uniqueField]
        } else {
          this.selectedOption = this.matchOfRepeatValue(options)
          this.unique = this.selectedOption[this.uniqueField]
        }
      } else if (this.allowCreate) {
        this.unique = this.value
      } else {
        this.unique = ''
      }
    },
    onInput(unique) {
      this.selectedOption = this.options.find(p => p[this.uniqueField] === unique) || null
      let value = ''
      if (this.selectedOption) {
        value = this.selectedOption[this.valueField]
      } else if (this.allowCreate) {
        value = unique
      }
      this.unique = unique
      this.$emit('input', value, this.selectedOption)
    },
    onChange(unique) {
      let value = ''
      if (this.selectedOption) {
        value = this.selectedOption[this.valueField]
      } else if (this.allowCreate) {
        value = unique
      }
      this.$emit('change', value, this.selectedOption)
    }
  }
}
</script>
